/*
 * TitleView Container.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { getView } from '../../helpers';


const DescriptionView = ({ pathname }) => {
    const action = getView(pathname);
    const description = useSelector((state) => state?.content?.data?.description);
    const type = useSelector((state) => state?.content?.data?.['@type']);
    const showDescription = action === 'view' && type != 'LRF' ? true : false

    return showDescription ? (
        <Container>
            {description && (
                <p className="documentDescription">{description}</p>
            )}
        </Container>
    ) : (<></>);
};

export default DescriptionView;